const SectionImage = ({ image }) => (
    <img key={image} className='w-full h-auto' src={image} alt="" />
)

export default SectionImage;
